import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import { Link } from "react-router-dom";

import LinkButton from "../../Buttons/LinkButton.js";

const StyledRecruitmentProcess = styled(NanoFlex)`
  height: auto;
  padding: 0 100px;
  gap: 34px;

  .titleBlockWrapper {
    height: auto;
  }

  .recruitmentBlockRow {
    height: auto;
    gap: 32px;

    .recruitmentBlock {
      min-height: 230px;
      padding: 24px;
      flex: 1 calc(33.33% - 32px);
      gap: 24px;
      border-radius: 10px;
      background: ${(props) => props.theme.color.primaryColors.purpleGradient};

      &:nth-child(2) {
        background: ${(props) => props.theme.color.primaryColors.yellowGradient};
      }

      &:nth-child(3) {
        background: ${(props) => props.theme.color.primaryColors.lighterPurple};
      }
      .recruitmentTitle {
        height: auto;
        h5 {
          text-transform: none;
          font-weight: 600;
        }
      }

      .recruitmentText {
        height: 100%;
        flex-grow: 1;

        p {
          color: ${(props) => props.theme.color.primaryColors.darkPurple};
        }
      }
      .recruitmentSeeMore {
        height: auto;
      }
    }
  }

  /* SMALL DESKTOPS */
  @media only screen and (max-width: 1450px) {
    padding: 0px 50px;
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0px 30px;

    .recruitmentBlockRow {
      .recruitmentBlock {
        height: 280px;
        flex: 1 100%;
        height: auto;
        max-width: 100%;
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    padding: 0 20px;
    .recruitmentBlockRow {
      gap: 16px;
      flex-wrap: wrap;
      .recruitmentBlock {
        flex: 1 calc(50% - 16px);
        max-width: 50%;
        border-radius: 5px;
        height: auto;
        min-height: unset;
        padding: 16px;

        .recruitmentText {
          flex-grow: 0;
        }

        &:nth-child(3) {
          min-width: 100%;
          height: auto;
          min-height: unset;
          .recruitmentText {
            flex-grow: 0;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 650px) {
    gap: 16px;

    .recruitmentBlockRow {
      gap: 16px;
      flex-wrap: wrap;
      .recruitmentBlock {
        min-width: 100%;
        height: auto;
        min-height: unset;
        gap: 8px;
        .recruitmentText {
          flex-grow: 0;
        }

        .recruitmentSeeMore {
          justify-content: flex-end;
        }
      }
    }
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
    padding: 0;
  }
`;

export default class RecruitmentProcess extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }
  render() {
    return (
      <StyledRecruitmentProcess flexDirection="column" className="aboutBlock">
        <NanoFlex className="titleBlockWrapper" justifyContent="flex-start">
          <Type.h5 className="bold">{this.translation.homepage.recruitmentProcess.recruitmentProcessTitle}</Type.h5>
        </NanoFlex>
        <NanoFlex className="recruitmentBlockRow" justifyContent="space-between" alignItems="flex-start">
          <NanoFlex className="recruitmentBlock" flexDirection="column" alignItems="flex-start">
            <NanoFlex className="recruitmentTitle" justifyContent="flex-start">
              <Type.h5>{this.translation.homepage.recruitmentProcess.forCandidates}</Type.h5>
            </NanoFlex>
            <NanoFlex className="recruitmentText" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.homepage.recruitmentProcess.textBlockOne}</Type.p>
            </NanoFlex>
            <NanoFlex className="recruitmentSeeMore" justifyContent="flex-start">
              <Link to="/recrutamento">
                <LinkButton label={this.translation.homepage.recruitmentProcess.seeMore}></LinkButton>
              </Link>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="recruitmentBlock" flexDirection="column" alignItems="flex-start">
            <NanoFlex className="recruitmentTitle" justifyContent="flex-start">
              <Type.h5>{this.translation.homepage.recruitmentProcess.forCompanies}</Type.h5>
            </NanoFlex>
            <NanoFlex className="recruitmentText" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.homepage.recruitmentProcess.textBlockTwo}</Type.p>
            </NanoFlex>
            <NanoFlex className="recruitmentSeeMore" justifyContent="flex-start">
              <Link to="/assessment">
                <LinkButton label={this.translation.homepage.recruitmentProcess.seeMore}></LinkButton>
              </Link>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="recruitmentBlock" flexDirection="column" alignItems="flex-start">
            <NanoFlex className="recruitmentTitle" justifyContent="flex-start">
              <Type.h5>{this.translation.homepage.recruitmentProcess.perfectMatch}</Type.h5>
            </NanoFlex>
            <NanoFlex className="recruitmentText" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.homepage.recruitmentProcess.textBlockThree}</Type.p>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledRecruitmentProcess>
    );
  }
}
